import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16 } from '@onefootprint/icons';
import * as Portal from '@radix-ui/react-portal';
import { AnimatePresence, easeInOut, motion } from 'framer-motion';
import IconButton from '../../../icon-button';
import Text from '../../../text';
type CommandDiscoverProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};
const CommandDiscover = t0 => {
  const $ = _c(6);
  const {
    open,
    onClose,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== onClose || $[2] !== open) {
    t1 = open && <motion.div className="hidden min-[900px]:flex min-[900px]:fixed min-[900px]:items-center min-[900px]:justify-between min-[900px]:gap-2 min-[900px]:rounded min-[900px]:py-1 min-[900px]:px-3 min-[900px]:bottom-2 min-[900px]:right-2 min-[900px]:z-[15] min-[900px]:bg-elevated min-[900px]:origin-bottom-right min-[900px]:shadow-[var(--elevation-1)]" initial={{
      translateX: "50%",
      opacity: 0
    }} animate={{
      translateX: "0%",
      opacity: 1,
      transition: {
        duration: 0.3,
        ease: easeInOut,
        delay: 0.2
      }
    }} exit={{
      translateX: "50%",
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: easeInOut
      }
    }}><Text variant="caption-2" color="secondary">{children}</Text><IconButton aria-label="Close" onClick={onClose} size="compact" icon={IcoCloseSmall16} /></motion.div>;
    $[0] = children;
    $[1] = onClose;
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <Portal.Root><AnimatePresence>{t1}</AnimatePresence></Portal.Root>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default CommandDiscover;